import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { actionsRest } from './utils/getActions';
import { isSmReadOnly } from '../../utils/request';

const Actions = ({ order, status, fetchOrders }) => {
  const smReadOnly = isSmReadOnly();
  const visibleActions = _.get(actionsRest, status, []).filter(
    Action => !smReadOnly || Action.actionType !== 'mutation'
  );
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {visibleActions.map(Action => (
        <Action status={status} orderData={order} fetchOrders={fetchOrders} />
      ))}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
